import React, { Component } from 'react';
import { Container, ContainerLarge, Article, Heading, FirstSection, Section, MainColumn, SideColumnRightLarge, Figure, KeySection } from '../../theme/grid';
import { OverlaySummery } from '../../theme/overlay';
import { HeadingH1, HeadingH2, DropCap } from '../../theme/typography';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import PageFooter from '../../components/PageFooter/PageFooter';
import Contrast from '../../assets/Mozilla/DesignTokens/Contrast/Contrast';
import Icons from '../../assets/Mozilla/DesignTokens/Icons/Icons';
import Typescale from '../../assets/Mozilla/DesignTokens/Typescale/Typescale';

const small = require('../../assets/Mozilla/DesignTokens/mozilla-resources.png');
const medium = require('../../assets/Mozilla/DesignTokens/mozilla-resources@2x.png');
const large = require('../../assets/Mozilla/DesignTokens/mozilla-resources@3x.png');

const MozillaIllo = () => (
  <img src={small} srcSet={`${small} 300w, ${medium} 768w, ${large} 1280w`} alt=""/>
);

export default class MozillaDesignTokens extends Component {
  static propTypes = {};
  
  constructor(props) {
      super(props)

      this.handler = this.handler.bind(this);

      if (this.props.location.hash == "#present") {
        this.state = {
            messageShown: false
        };
      } else {
        this.state = {
            messageShown: true
        };
      }
  }

  handler() {
      this.setState({
          messageShown: !this.state.messageShown
      });
  }

  render() {
    return (
      <div>
      <Header theme={"mozilla " + this.state.messageShown} color="#FF0900" date="Winter 2019" role="Concept, Design, Development" action={this.handler}></Header>
          <Article className={"mozilla " + this.state.messageShown}>
            <Container className={this.state.messageShown}>
                <Heading className={this.state.messageShown}>
                  <HeadingH2 className="mozilla">Mozilla</HeadingH2>
                  <HeadingH1>Design Tokens</HeadingH1>
                  <OverlaySummery className={this.state.messageShown}>
                    <p>I designed the plugin to make it as easy as possible to start working with Mozilla's brand assets.</p>
                    <ul>
                      <li>Imports Layer Styles</li>
                      <li>Interchangable Layer Styles</li>
                      <li>Updates Layer Fills</li>
                    </ul>
                  </OverlaySummery>
                </Heading>
              <FirstSection className={this.state.messageShown}>
                <MainColumn>
                  <p><DropCap>B</DropCap>efore I started at Mozilla we didn't have a clear single source of truth for our design work. This meant that designers and developers were unintentionally using slightly different design variables (colors, spacing, typography, etc.) when working on a new page/feature. My solution to this was to introduce this concept of design tokens and create an NPM package with those stored values that was then pulled in to a custom sketch plugin and our design system.</p>
                  <p>Design Tokens are generally the smallest variable used to design a website, an application, or a branded piece of graphic art. Most design token sets include variables for color, typography, and spacing. I created our design token github repository, NPM package, and ultimately decided on which design variables should be included and the value of those variables.</p> 
                  <p>This work included conducting an audit of our existing designs by documenting the colors, typography, spacing, and other variables used; consolidating and adjusting those values by making the colors more accessible, introducing a new grid system, and setting up a typographic scale. All of this work had to be flexible enough to work for both the Firefox and Mozilla brands.</p>
                </MainColumn>
              </FirstSection>
              <Section className={this.state.messageShown}>
                <MainColumn>
                <h2>Colors</h2>
                <p>Early on, one of the biggest issues we were trying to resolve was our inconsistent and unaccessible use of color. Mozilla at the time had a small brand color palette that only included 11 colors, this made it difficult for designers design pages and applications that a needed a variety of colors to show different states and to indicate different things to the user. Designers out of necessity were using colors that weren't part of the official brand palette this led to a lot of inconsistencies across our different products, we had easily over a dozen different shades of blue being used for things like links.</p>
                <p>Accessibility was a huge concern of ours. On the Marketing website we were using a shade of green for our Firefox download button that made the text illegible. We knew that one of the best ways to resolve these issues was to introduce a new color palette with more options and written documentation on accessibility. We tested how accessible our color would be by using guidelines provided by the WCAG, I also introduced the rest of the design team to a plugin called Stark which let's a designer select any two elements in Sketch and test the accessibility of the color pairing.</p>
                </MainColumn>
              </Section>
              <KeySection className={this.state.messageShown}>
                <Figure>
                  <Contrast/>
                </Figure>
              </KeySection>
              <Section className={this.state.messageShown}>
                <MainColumn>
                  <h2>Icons</h2>
                  <p>I designed the icon system used in our products and websites. Similair to my work with colors the first step in this process was to conduct an audit of our current icon use. From there I found that our most commonly used icons size was about 24px in diameter. Starting from that size I started to draw an icon to represent Mozilla's logo. That icon informed a lot of the design decisions that would be definded and used to create the rest of the icon set. I chose flat ends and joins to match the sharpness of the Mozilla logo. I then went with a 2pt stroke, this gave the icons just enough visibility at that small of a size while also maxizing the amount of details we could include to accurately represent some of our more obscure icons.</p>
                  <p>Overall I drew over 100 different icons in preperation for Mozilla's rebranding. During the construction of these icons I made sure the paths all joined in the center so the icons can be scaled up and down, the stroke weight can be increased or decreased, and the end/joins can be either round or square. This makes it easier to update this set of icons for any future rebranding efforts.</p>
                </MainColumn>
              </Section>
              <Section className={this.state.messageShown}>
                <Figure>
                  <Icons/>
                </Figure>
              </Section>
              {/*<Section>
                <Figure>
                  <Tokens/>
                </Figure>
              </Section>
              <Section>
                <Figure>
                  <Icon alt="" src={require('../../assets/Mozilla/DesignTokens/icon/accessibility.svg')} />
                  <Icon alt="" src={require('../../assets/Mozilla/DesignTokens/icon/accounts.svg')} />
                  <Icon alt="" src={require('../../assets/Mozilla/DesignTokens/icon/add-search-engine.svg')} />
                  <Icon alt="" src={require('../../assets/Mozilla/DesignTokens/icon/arrow-down.svg')} />
                  <Icon alt="" src={require('../../assets/Mozilla/DesignTokens/icon/arrow-left.svg')} />
                  <Icon alt="" src={require('../../assets/Mozilla/DesignTokens/icon/arrow-right.svg')} />
                  <Icon alt="" src={require('../../assets/Mozilla/DesignTokens/icon/arrow-up.svg')} />
                  <Icon alt="" src={require('../../assets/Mozilla/DesignTokens/icon/audio-card.svg')} />
                  <Icon alt="" src={require('../../assets/Mozilla/DesignTokens/icon/audio-mute.svg')} />
                  <Icon alt="" src={require('../../assets/Mozilla/DesignTokens/icon/audio.svg')} />
                  <Icon alt="" src={require('../../assets/Mozilla/DesignTokens/icon/auto-play-block.svg')} />
                  <Icon alt="" src={require('../../assets/Mozilla/DesignTokens/icon/back.svg')} />
                  <Icon alt="" src={require('../../assets/Mozilla/DesignTokens/icon/beta.svg')} />
                  <Icon alt="" src={require('../../assets/Mozilla/DesignTokens/icon/blog.svg')} />
                  <Icon alt="" src={require('../../assets/Mozilla/DesignTokens/icon/bookmark-menu.svg')} />
                  <Icon alt="" src={require('../../assets/Mozilla/DesignTokens/icon/bookmark-remove.svg')} />
                  <Icon alt="" src={require('../../assets/Mozilla/DesignTokens/icon/bookmark.svg')} />
                  <Icon alt="" src={require('../../assets/Mozilla/DesignTokens/icon/brightness.svg')} />
                  <Icon alt="" src={require('../../assets/Mozilla/DesignTokens/icon/browser.svg')} />
                  <Icon alt="" src={require('../../assets/Mozilla/DesignTokens/icon/calendar.svg')} />
                  <Icon alt="" src={require('../../assets/Mozilla/DesignTokens/icon/careers.svg')} />
                </Figure>
              </Section>*/}
              <Section className={this.state.messageShown}>
                <MainColumn>
                  <h2>Typography</h2>
                  <p>Mozilla has it's own custom typeface, Zilla Slab, a chunky display font. That typeface is instantly recognizable has a ton of character and is used in Mozilla's logo. One of the most unique aspects of this typeface is the inclusion of a "highlight" variant, this variant changes the text color to white and adds a colored background to each one of the letters. The overall effect is similar to highlighting something with your browser cursor. In order to acheive this affect when Zilla Slab was constructed the height of the letters was reduced to add extra space above the ascenders and decenders of each letter. This was a great solution but it quickly started to complicate things when we came up with this idea of one set of tokens that could be applied to both the Mozilla and Firefox brands.</p>
                  <p>Our ultimate goal was to have a set of tokens that was flexible enough to work on either Mozilla branded pages or Firefox branded pages. The Firefox brand identify was going through a refresh and we landed on Sharp Sans as the new typeface for the brand. During this rebranding we weren't sure which pages would remain Mozilla branded and which pages would become Firefox branded so we knew we needed a set of design tokens that could be applied in either instance.</p>
                </MainColumn>
              </Section>
              <Section className={this.state.messageShown}>
                <Figure>
                  <Typescale/>
                </Figure>
              </Section>
              <Section className={this.state.messageShown}>
                <MainColumn>
                  <p>The solution was to create a typescale for our newest typeface, Firefox Sharp Sans, which was set to become the dominant typeface used in our websites and products. I then created a seperate typescale for Zilla Slab that increased the font-size so that the height of the letters would be roughly equivelant to the height of the letters used in the Sharp Sans typescale.</p>
                </MainColumn>
              </Section>
              <Section className={this.state.messageShown}>
                <MainColumn>
                  <h2>NPM Package</h2>
                  <p>Design tokens should be a single source of truth stored in one location and distributed to various platforms. This ensures that anytime a design tokens value needs to be updated that change can be made in one location and automatically implemented across all of the products that consume those design tokens.</p>
                  <p>I set up a github repository where the individual variable names and values were stored. I then implemented a plugin called Theo that formats those values for different platforms include the web, i0S, and Android. I then published our design tokens as a package via NPM.</p>
                </MainColumn>
              </Section>
              <Section className={this.state.messageShown}>
                  <img alt="" style={{boxShadow: 'none'}} src={require('../../assets/Mozilla/DesignTokens/distribution.png')} width="100%" />
              </Section>
              <Section className={this.state.messageShown}>
                <MainColumn>
                  <h2>Sketch Integration</h2>
                  <p>To make the design tokens available to the design team, I made a Sketch Plugin which pulls in the design token values via the NPM package and creates layer styles and layer fills using those values.</p>
                </MainColumn>
              </Section>
              <Section className={this.state.messageShown}>
                  <MainColumn>
                  <img alt="" style={{boxShadow: 'none'}} src={require('../../assets/Mozilla/SketchPlugin/sketch-preferences@2x.png')} width="100%" />
                  </MainColumn>
                  <SideColumnRightLarge>
                  	<MozillaIllo/>
                  </SideColumnRightLarge>
              </Section>
            </Container>
          </Article>
          <PageFooter present={this.state.messageShown} theme="mozilla" leftTitle="Amazon" left="Data Plugin" leftLink="amazon-data-plugin" rightTitle="Mozilla" right="Component Editor" rightLink="mozilla-component-editor"/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/containers/MozillaDesignTokens/DesignTokens.js